import { useTranslation } from "react-i18next";

const CTASection = () => {
  const { t } = useTranslation();

  const goToContact = () => { window.location.href = "/contact"; };

  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20cleaning%20crew%20in%20matching%20dark%20navy%20uniforms%20with%20commercial%20equipment%20in%20a%20gleaming%20modern%20corporate%20office%20lobby%2C%20polished%20marble%20floors%2C%20floor%20to%20ceiling%20glass%2C%20pristine%20environment%2C%20premium%20commercial%20interior%20photography%2C%20inspiring%20spotless%20business%20atmosphere&width=1920&height=700&seq=cta_commercial001&orientation=landscape"
          alt="Professional commercial cleaning team"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#0F2A44]/88" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          {t("cta_headline")}
        </h2>
        <p className="text-white/70 text-lg mb-10">{t("cta_sub")}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
          <button
            onClick={goToContact}
            className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#B8952E] text-[#0F2A44] font-bold px-10 py-4 rounded-full text-base transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: "0 4px 24px rgba(212,175,55,0.4)" }}
          >
            {t("cta_primary")}
            <i className="ri-arrow-right-line" />
          </button>
          <a
            href="tel:+12064744668"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/50 hover:border-white text-white font-semibold px-10 py-4 rounded-full text-base transition-all duration-200 hover:bg-white/10 whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("cta_secondary")}
          </a>
        </div>

        <p className="text-white/45 text-sm">{t("cta_note")}</p>
      </div>
    </section>
  );
};

export default CTASection;
